import styled from 'styled-components';

export const StyledWarning = styled.div`
  height: 48px;
  width: 100%;
  background-color: var(--accent100);
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
`;
